// extracted by mini-css-extract-plugin
module.exports = {"pdf":"styles__pdf___-RRtE","pagination":"styles__pagination___iQJ0i","button":"styles__button___QU_xV","building":"styles__building___3KY4Q"};